import Chart from 'react-apexcharts';

const LineChart = ({ title, subtitle, series, categories, colors = ['#137dc5', '#13c56d'] }) => {
    return (
        <Chart
            options={{
                chart: {
                    type: 'line',
                    toolbar: {
                        show: true,
                    },
                },
                title: {
                    text: title,
                    align: 'left',
                    style: {
                        fontSize: '16px',
                        color: '#131313',
                        fontFamily: 'Segoe UI',
                        fontWeight: 650,
                    },
                },
                subtitle: {
                    text: subtitle,
                    align: 'left',
                    style: {
                        fontSize: '12px',
                        color: '#131313',
                        fontFamily: 'Segoe UI',
                        fontWeight: 500,
                    },
                },
                stroke: {
                    curve: 'smooth',
                    width: 3,
                },
                dataLabels: {
                    enabled: false,
                },
                markers: {
                    size: 4,
                    hover: {
                        size: 6,
                    },
                },
                xaxis: {
                    categories: categories?.length ? categories : [],
                },
                colors: colors,
                legend: {
                    show: true,
                    position: 'top',
                    horizontalAlign: 'right',
                },
                grid: {
                    borderColor: '#e7e7e7',
                },
            }}
            series={series}
            type="line"
            height={360}
            width="100%"
        />
    );
};

export default LineChart;
